export default {
  en: {
    "pricing.loading": "Loading pricing information...",
    "pricing.error": "Could not fetch pricing information.",
    "pricing.subscribe": "Sign in to Subscribe",
    "pricing.subtitle": "Unlock the full power of the archive with a subscription plan that fits your needs.",
    "pricing.monthly": "Monthly",
    "pricing.annual": "Annual",
    "pricing.annualSave": "Save {percent}%",
    "pricing.perMonth": "/mo",
    "pricing.perYear": "/yr",
    "pricing.freeTier": "Free",
    "pricing.currentPlan": "Current Plan",
    "pricing.popular": "Most Popular",
    "pricing.feature.viewsPerHour": "Page views / hour",
    "pricing.feature.downloadsPerHour": "Downloads / hour",
    "pricing.feature.pageDownload": "Page downloads",
    "pricing.feature.pdfDownload": "Issue PDF download",
    "pricing.feature.ocrSearch": "Full-text OCR search",
    "pricing.feature.collections": "Collections",
    "pricing.feature.aiTarihci": "Archive assistant (messages / month)",
    "pricing.comparison.title": "Compare Plans",
    "pricing.comparison.feature": "Feature",
    "pricing.stats.newspapers": "100+",
    "pricing.stats.newspapersLabel": "Newspapers",
    "pricing.stats.years": "150+",
    "pricing.stats.yearsLabel": "Years of History",
    "pricing.stats.pages": "1M+",
    "pricing.stats.pagesLabel": "Newspaper Pages",
    "pricing.stats.users": "10,000+",
    "pricing.stats.usersLabel": "Registered Users",
    "pricing.guarantee": "Secure payment via Stripe. Cancel anytime.",
    "pricing.subscribeNow": "Subscribe Now",
    "pricing.checkoutError": "Could not open the payment page. Please try again.",
    "pricing.faq.title": "Frequently Asked Questions",
    "pricing.faq.q1": "Can I cancel my subscription anytime?",
    "pricing.faq.a1": "Yes, you can cancel your subscription at any time from your account settings. Your access will continue until the end of your current billing period.",
    "pricing.faq.q2": "What payment methods do you accept?",
    "pricing.faq.a2": "We accept all major credit cards (Visa, Mastercard, American Express) through our secure payment processor, Stripe.",
    "pricing.faq.q3": "What happens when I reach my hourly limit?",
    "pricing.faq.a3": "Your hourly page view and download limits reset automatically at the start of each hour. You can also upgrade your plan for higher limits.",
    "pricing.faq.q4": "Can I upgrade or downgrade my plan?",
    "pricing.faq.a4": "Yes, you can change your plan at any time. Upgrades take effect immediately, while downgrades apply at the end of your current billing period.",
    "pricing.cta.title": "Ready to Explore History?",
    "pricing.cta.subtitle": "Join thousands of researchers and history enthusiasts exploring our archive.",
    "pricing.cta.button": "Start Your Journey",
    "subscriptionSuccess.title": "Subscription Successful!",
    "subscriptionSuccess.thankYou": "Thank you for subscribing to History Worm!",
    "subscriptionSuccess.enjoyFeatures": "You now have access to all premium features and can explore the archive with higher limits.",
    "subscriptionSuccess.processingTime": "It may take a few minutes for your subscription to appear on your account. Please try again shortly if your subscription does not show up.",
    "subscriptionSuccess.goToAccount": "Go to My Account",
    "name": "History Worm",
    "yükleniyor": "Loading...",
    "home" : "Home Page",
    "loading" : "Loading...",

    "index.arşivdeki_gazeteler" : "Newspapers in the archive",
    "index.desc": "Lets you read issues of old newspapers and see clippings of them.",
    "index.page_title": "History Worm | 150+ Years of Old Newspapers — Digital Archive from the Ottoman Era to Today",
    "index.aramalarTitle" : "Most searched today:",
    "index.tarihte_bugun": "Events on this day in history:",
    "tarihte_bugun.view_full": "Open full page",
    "tarihte_bugun.meta.title": "Today in history — {date} | {name}",
    "tarihte_bugun.meta.description":
      "Historical events and birthdays on {date}, with links to digitized newspaper front pages from the archive. {name}",
    "tarihte_bugun.breadcrumb": "Today in history",
    "tarihte_bugun.title_fallback": "Today in history",
    "tarihte_bugun.prev_day": "Previous day",
    "tarihte_bugun.next_day": "Next day",
    "tarihte_bugun.jump_today": "Go to today’s calendar day",
    "tarihte_bugun.empty": "No events or birthdays have been added for this day yet.",
    "tarihte_bugun.random_covers": "Random front pages from this date in past years",
    "tarihte_bugun.section.events": "Historical events",
    "tarihte_bugun.section.birthdays": "Birthdays",
    "tarihte_bugun.not_found": "Page not found.",
    "tarihte_bugun.no_data_today": "There is no today in history entry for this date yet.",
    "index.gecmisten_bugun": "Random newspapers dated today in history:",
    "index.gunun_mansetleri": "Today's headlines",
    "index.gunun_mansetleri_view_all": "View all",
    "index.yillarTitle": "Years in the archive:",
    "index.yil_link": "{yil} Year",
    "index.hero_title": "150+ Years of Newspaper Archive",
    "index.show_all_newspapers": "Show All Newspapers",
    "index.show_less": "Show Less",
    "index.show_more": "Show More",
    "index.step_search": "Search",
    "index.step_search_desc": "Search through millions of newspaper pages with keywords.",
    "index.step_explore": "Explore",
    "index.step_explore_desc": "Browse the archive by date, year, or newspaper name.",
    "index.step_download": "Download",
    "index.step_download_desc": "Download newspaper pages and clippings to your device.",
    "index.assistant_promo.title": "Meet {name}",
    "index.assistant_promo.body": "{name} answers your history questions using the newspaper archive. For subscribers.",
    "index.assistant_promo.cta": "Open chat",

    "assistant.metaDescription": "Chat with {name} about history. Answers draw on digitized newspaper pages. A subscriber feature.",
    "assistant.heroSubtitle": "{name} searches the archive and replies in plain language. Monthly messages depend on your plan.",
    "assistant.loginPrompt": "Sign in with an active subscription to chat with {name}.",
    "assistant.subscribePrompt": "{name} is for subscribers. Each plan includes a monthly message allowance.",
    "assistant.emptyHint": "For example: “What were newspapers writing about İnönü in 1938?” or “How was the occupation of İzmir reflected during the War of Independence?”",
    "assistant.sourcesLabel": "Pages in the archive",
    "assistant.quota": "Messages left this month",
    "assistant.placeholder": "Write your question…",
    "assistant.send": "Send",
    "assistant.limitReached": "You have used your monthly messages. Your allowance renews with your billing period, or you can upgrade your plan.",
    "assistant.error.limit": "Monthly message limit reached.",
    "assistant.error.subRequired": "This feature is for subscribers.",
    "assistant.connectionError": "Connection error",
    "assistant.thinking": "Preparing a reply",
    "assistant.newChat": "New chat",
    "assistant.noTitle": "Untitled",
    "assistant.loadError": "Could not load conversations.",
    "assistant.deleteConfirm": "Delete this conversation?",

    "ara.cta" : "Search in newspapers",
    "ara.fromDate" : "Start date:",
    "ara.endDate" : "End date:",
    "ara.gazete" : "Newspaper:",
    "ara.button" : "Search",
    "ara.cancel" : "Cancel",
    "ara.aciklama": "You can search similar to how you search in search engines, using OR in between terms or putting them in double quotes.",

    "footer.emailCta" : "For all support, inquiry and suggestion messages",
    "footer.email": "contact@historyworm.com",
    "footer.about.desc": "Digital archive of newspaper pages from Ottoman era to present.",
    "footer.quickLinks": "Quick Links",
    "footer.search": "Search",
    "footer.research": "Research",
    "footer.assistant_chat": "{name}",
    "footer.collections": "Collections",
    "footer.todaysHeadlines": "Today's headlines",
    "footer.sisterSites": "Sister Sites",
    "footer.contactTitle": "Contact",
    "footer.privacy": "Privacy Policy",

    "tarih.meta.title" : "Newspapers dated {tarih} | History Worm",
    "tarih.meta.description" : "Read newspapers dated {tarih} from the archive. What happened on {tarih}. {tarih} news",
    "tarih.title" : "Newspapers dated {tarih}",
    "tarih.gunBilgisi": "What happened on this day?",
    "tarih.showMore": "Show more",
    "tarih.showLess": "Show less",
    "tarih.commonTags": "Tags of the day",
    "tarih.newsArticles": "News articles for this day",

    "gunun_mansetleri.meta.title": "Today's headlines | History Worm",
    "gunun_mansetleri.meta.description": "Browse today's newspaper front pages from the archive. Today's headlines page.",
    "gunun_mansetleri.page_title": "Today's headlines — {tarih}",

    "ara.meta.title" : "{query} | History Worm",
    "ara.meta.desc" : "Results of {query} search in old newspapers. {query} news. History of {query}",
    "ara.kupurler" : "Clippings found",
    "ara.sayfalar" : "Pages found",
    "ara.sayfaTitle" : "{ad} {tarih} Page {sayfa}",
    "ara.sayfalar.baslik": "Pages containing {query}",
    "ara.pagination.arialabel": "Pages",
    "ara.yilPageLink": "Go to year {year} →",
    "ara.tarihPageLink.human": "Go to {date, date, long} →",

    "ara.sort": "Sort:",
    "ara.sort.best": "Best Match",
    "ara.sort.date": "By Date",
    "ara.filters": "Filters",
    "ara.tags": "Tags",
    "ara.resultCount": "{count} results",
    "ara.gazetelerCount": "{count} newspapers",
    "ara.etiketlerCount": "{count} tags",
    "ara.clearAll": "Clear",
    "ara.page.h1": "{query} — newspaper archive search",
    "ara.page.h1.empty": "Newspaper archive search",

    "Gazete.description" : "Read historic issues of {ad} newspaper. {ad} archive.",
    "Gazete.arasıSayılar" : "Issues from {ilk} to {son}",
    "Gazete.title" : "{ad} {tip} Archive",
    "Gazete.archiveInfo": "The archive contains {toplamSayi} issues between {ilkYil} and {sonYil}. You can select a date from the calendar or browse all issues.",
    "Gazete.allIssues": "All issues",
    "Gazete.allIssuesPage": "All issues page {page}",

    "GazeteSayısı.meta.title" : "{gazete} {tarih} | History Worm",
    "GazeteSayısı.meta.desc" : "Read {gazete} issue dated {tarih} from the archive.",
    "GazeteSayısı.og.title" : "{gazete} issue dated {tarih}",
    "GazeteSayısı.og.desc" : "Read all issues from the archive.",
    "GazeteSayısı.title" : "{gazete} dated {tarih}",
    "GazeteSayısı.sayfaTitle" : "Page {sayfa}",

    "year.title" : "{year} Newspaper Archive - What Happened in {year} | History Worm",
    "year.description" : "Browse newspaper pages from {year}. Discover what happened in {year}, read historical newspaper issues day by day, and explore archived headlines and front pages.",
    "year.breadcrumb" : "{year} Year",
    "year.heading" : "Newspaper Pages from {year} - Day by Day Archive",
    "year.invalidYear" : "Please enter a valid year. This year does have any issues in the archive.",
    "year.dayWithIssues" : "{date} - Has newspaper issues",
    "year.dayWithIssuesAriaLabel" : "Day {day} of {month} {year} - Has newspaper issues",
    "year.legend.noissues" : "Days without issues",
    "year.legend.withIssues" : "Days with issues",
    "year.commonTags": "Common tags of the year",
    "year.showMore": "Show more",
    "year.og.title": "{year} Newspaper Archive - Historical Newspaper Pages | History Worm",
    "year.og.description": "Explore all newspaper pages from {year}. Browse daily issues, see what made the headlines, and read archived newspapers from the year {year}.",

    "year.etiket.title": "{year} Year {tag} Pages | History Worm",
    "year.etiket.description": "Pages tagged with {tag} in {year} year in the newspaper archive.",
    "year.etiket.heading": "Pages for '{tag}' in {year}",
    "year.etiket.error": "An error occurred while loading tagged pages.",
    "year.etiket.empty": "No pages found for this tag in this year.",

    "year.showLess": "Show less",

    "GazeteSayfası.küpürlerTitle" : "Clippings belonging to page",
    "GazeteSayfası.metinİçeriği" : "Full text content",
    "GazeteSayfası.meta.title" : "{ad} {tarih} Page {sayfa} | History Worm",
    "GazeteSayfası.meta.description" : "Read {ad} dated {tarih}, page {sayfa} from archive",
    "GazeteSayfası.meta.headline" : "{ad} dated {tarih}, page {sayfa} from archive",
    "GazeteSayfası.og.title" : "{ad} dated {tarih}, page {sayfa}",
    "GazeteSayfası.sonrakiGun" : "Next Day",
    "GazeteSayfası.oncekiGun" : "Previous Day",
    "GazeteSayfası.aynıGün" : "Other newspapers of the same day",
    "GazeteSayfası.sayfa" : "Page {sayfa}",
    "GazeteSayfası.oncekiSayfa" : "Previous page",
    "GazeteSayfası.sonrakiSayfa" : "Next page",
    "GazeteSayfası.title": "{ad} Newspaper, {tarih}, Page {sayfa}",
    "GazeteSayfası.imageAlt": "Newspaper of {ad} dated {tarih} Page {sayfa}",
    "GazeteSayfası.digerSayfalar": "Other pages from this issue:",
    "GazeteSayfası.cut": "Cut",
    "GazeteSayfası.add": "Add",
    "GazeteSayfası.download": "Download",
    "GazeteSayfası.downloadPdf": "Download Issue PDF",
    "GazeteSayfası.downloadPdfTooltip": "Download this issue as PDF",
    "GazeteSayfası.downloadPdfAriaLabel": "Download PDF",
    "GazeteSayfası.downloadPdfCta": "You can download the entire issue as a PDF by subscribing! Enjoy this exclusive benefit for our subscribers—subscribe now and unlock PDF downloads.",
    "GazeteSayfası.downloadPdfError": "Failed to download PDF. Please try again later.",
    "GazeteSayfası.tags": "Tags:",
    "GazeteSayfası.pageLimit": "You have reached the hourly page view limit. Unlock higher limit to our entire archive!",
  "GazeteSayfası.limitExplanation": "Subscribers enjoy higher page view limit, downloads, and exclusive features. Your subscription is secure and you can cancel anytime easily.",
    "GazeteSayfası.limitKalan": "Page views left: {limit}",
    "GazeteSayfası.softPaywallCritical": "Only {remaining} views remaining! Subscribe to a higher limit.",
    "GazeteSayfası.osShare": "Share",
    "GazeteSayfası.downloadCta": "You can download newspaper pages by subscribing! Enjoy this exclusive benefit for our subscribers—subscribe now and unlock downloads.",
    "GazeteSayfası.cropTooltip": "Crop (Select region)",
    "GazeteSayfası.cropAriaLabel": "Crop",
    "GazeteSayfası.cancelCropTooltip": "Cancel cropping",
    "GazeteSayfası.cancelCropAriaLabel": "Cancel",
    "GazeteSayfası.cancelCrop": "Cancel",
    "GazeteSayfası.applyCropTooltip": "Apply cropping",
    "GazeteSayfası.applyCropAriaLabel": "Apply",
    "GazeteSayfası.applyCrop": "Apply",
    "GazeteSayfası.addToCollectionTooltip": "Add to collection",
    "GazeteSayfası.addToCollectionAriaLabel": "Add to collection",
    "GazeteSayfası.downloadTooltip": "Download page",
    "GazeteSayfası.downloadAriaLabel": "Download",
    "GazeteSayfası.shareFacebookTooltip": "Share on Facebook",
    "GazeteSayfası.shareFacebookAriaLabel": "Share on Facebook",
    "GazeteSayfası.shareWhatsappTooltip": "Share on Whatsapp",
    "GazeteSayfası.shareWhatsappAriaLabel": "Share on Whatsapp",
    "GazeteSayfası.sharePinterestTooltip": "Share on Pinterest",
    "GazeteSayfası.sharePinterestAriaLabel": "Share on Pinterest",
    "GazeteSayfası.shareTwitterTooltip": "Share on Twitter",
    "GazeteSayfası.shareTwitterAriaLabel": "Share on Twitter",
    "GazeteSayfası.shareOSTooltip": "Share on device",
    "GazeteSayfası.shareOSAriaLabel": "Share on device",
    "GazeteSayfası.backToTopAriaLabel": "Back to top",
    "GazeteSayfası.backToTopTooltip": "Back to top",
    "GazeteSayfası.censoredLegalTitle": "Access to this page is restricted for legal reasons in your country.",
    "GazeteSayfası.censoredLegalExplanation": "This newspaper page cannot be displayed due to legal restrictions in effect in your country.",
    "GazeteSayfası.showLess": "Show less",
    "GazeteSayfası.showMore": "more",
    "GazeteSayfası.summary": "Summary",
    "GazeteSayfası.copyText": "Copy text",
    "GazeteSayfası.textCopied": "Text copied",
    "GazeteSayfası.downloadLimitError": "You have reached your download limit. Please wait for it to reset or upgrade your subscription.",
    "GazeteSayfası.downloadError": "Failed to download the file. Please try again later.",

    "login.giris_yap": "Sign in",
    "login.k_adi": "Username",
    "login.sifre": "Password",
    "login.uye_ol_cta": "Not a member? Sign up now!",
    "login.uye_ol": "Sign up",
    "login.patreon": "Log in with Patreon",
    "login.google": "Sign in with Google",
    "login.forgot_password": "Forgot Password?",
    "login.reset_email_sent": "If the email exists, a reset link has been sent.",
    "login.send_reset": "Send Reset Link",
    "login.cancel": "Cancel",
    "login.set_new_password": "Set New Password",
    "login.reset_link_invalid": "This reset link is missing or invalid. Request a new one from the sign-in screen.",
    "login.password_strength_hint": "Use at least 8 characters including upper and lowercase letters, a number, and a symbol.",
    "login.password_reset_success": "Password has been reset. You can now log in.",
    "login.set_password": "Set Password",
    "login.back_to_login": "Back to Login",
    "login.or": "or",
    "login.greeting": "Welcome! 👋",

    "signup.email": "E-mail",
    "signup.login_cta": "Already a member? Sign in!",
    "signup.login": "Sign in",

    "subscribeModal.cta": "Unlock the full power of History Worm!",
    "subscribeModal.button": "Subscribe Now",
    "subscribeModal.cancel": "I'll think about it",
    "subscribeModal.p1": "Subscribe to download pages, get unlimited views, and explore 150+ years of newspaper history without limits.",
    "subscribeModal.feature.downloads": "High-quality page downloads",
    "subscribeModal.feature.unlimitedViews": "More page views per hour",
    "subscribeModal.feature.pdf": "Full-issue PDF downloads",
    "subscribeModal.feature.ocrSearch": "Full-text OCR search",
    "subscribeModal.choosePlan": "Choose the plan that fits your needs:",
    "subscription.title": "Subscription Packages",
    "subscription.description": "Hello {username}, you can access all features of the History Worm by subscribing. You can choose a suitable package from the subscription packages below.",
    "subscription.manage": "Manage subscription",

    "header.chooseOption": "--Please choose an option--",
    "header.flexibleSearch": "Flexible search:",
    "header.account": "Account",
    "header.signin": "Sign In",
    "header.signup": "Sign Up",

    "account.hello": "Hello, {username}",
    "account.subscription": "Subscription: {subscription}",
    "account.notSubscribed": "You are not a subscriber",
    "account.manageSubscription": "Manage subscription",
    "account.subscribe": "Subscribe",
    "account.collections": "Your collections:",
    "account.noCollections": "You haven't created any collections yet.",
    "account.supportPatreon": "Support on Patreon!",
    "account.logout": "Log out",
    "account.loading": "Loading...",
    "account.subscriptionPastDue": "Retrying payment",
    "account.manageSubscriptionTooltip": "Manage your subscription",
    "account.subscribeTooltip": "Subscribe and enjoy the benefits",
    "account.viewCollection": "View collection",
    "account.createCollectionCta": "You can create a new collection by searching!",
    "account.supportPatreonTooltip": "Support us on Patreon",
    "account.logoutTooltip": "Log out and leave your account securely",
    "account.viewLimit": "Views left: {left}, resets at: {resetAt}",
    "account.downloadLimit": "Page downloads left: {left}, resets at: {resetAt}",
    "account.downloadCredits": "Additional pagedownload credits: {credits}",
    "account.purchaseCredits": "Purchase Page Download Credits",
    "account.limits": "Limits",
    "downloadCredits.title": "Purchase Download Credits",
    "downloadCredits.currentBalance": "Current credits: {balance}",
    "downloadCredits.description": "Purchase additional download credits to use when your hourly download limit is exhausted.",
    "downloadCredits.pdfCostsCredits": "Downloading a full newspaper as a PDF uses one credit per page in that file, so a long issue can use many credits at once.",
    "downloadCredits.trySinglePage": "To use fewer credits, download a single page instead of the full PDF; that costs only one credit.",
    "downloadCredits.credits": "{count} Credits",
    "downloadCredits.continue": "Continue",
    "downloadCredits.cancel": "Cancel",
    "downloadCredits.loading": "Loading...",
    "downloadCredits.processing": "Processing...",
    "downloadCredits.pay": "Purchase",
    "downloadCredits.paymentTitle": "Payment Details",
    "downloadCredits.paymentDescription": "{credits} credits for {price}",
    "downloadCredits.successTitle": "Purchase Successful!",
    "downloadCredits.successMessage": "{credits} download credits have been added to your account.",
    "downloadCredits.packageDescription": "{count} download credits",
    "downloadCredits.fetchError": "Failed to load packages. Please try again.",
    "downloadCredits.paymentError": "Failed to initiate payment. Please try again.",
    "GazeteSayfası.downloadLimitErrorWithCredits": "You have reached your download limit. You can purchase additional download credits.",
    "GazeteSayfası.buyCredits": "Buy Credits",
    "etiket.title": "{etiket} tag | History Worm",
    "etiket.description": "Newspaper pages from the archive related to {etiket}.",
    "etiket.taggedPages": "Pages tagged with {etiket}",
    "etiket.goToDefinition": "Go to definition",
    "etiket.richDescription": "{toplam} pages found related to \"{etiket}\", spanning {minYear}–{maxYear}.",
    "etiket.richDescriptionNoRange": "{toplam} pages found related to \"{etiket}\".",
    "etiket.relatedTags": "Related Tags",
    "etiket.schema.name": "{etiket} tag — newspaper pages",
    "Gazete.navigation": "Results navigation",
    "index.intro": "Explore the digital archive of newspapers, travel back in time, discover old issues, and easily access the news you are looking for.",

    "datePicker.months.0": "January",
    "datePicker.months.1": "February",
    "datePicker.months.2": "March",
    "datePicker.months.3": "April",
    "datePicker.months.4": "May",
    "datePicker.months.5": "June",
    "datePicker.months.6": "July",
    "datePicker.months.7": "August",
    "datePicker.months.8": "September",
    "datePicker.months.9": "October",
    "datePicker.months.10": "November",
    "datePicker.months.11": "December",
    "datePicker.weekdays.0": "Sun",
    "datePicker.weekdays.1": "Mon",
    "datePicker.weekdays.2": "Tue",
    "datePicker.weekdays.3": "Wed",
    "datePicker.weekdays.4": "Thu",
    "datePicker.weekdays.5": "Fri",
    "datePicker.weekdays.6": "Sat",
    "datePicker.prevMonth": "Previous month",
    "datePicker.nextMonth": "Next month",
    "datePicker.selectYear": "Select year",
    "datePicker.selectMonth": "Select month",
    "datePicker.noIssues": "No issues available for this date",
    "datePicker.hasIssues": "Has issues",
    "datePicker.noIssuesLegend": "No issues",

    "collection.public": "Public",
    "collection.private": "Private",
    "collection.makePublic": "Make Public",
    "collection.makePrivate": "Make Private",
    "collection.makePublicLabel": "Make this collection public",
    "collection.publicHint": "Public collections can be seen and liked by everyone.",
    "collection.by": "by {username}",
    "collection.itemCount": "{count} pages",
    "collection.likeTooltip": "Like this collection",
    "collection.loginToLike": "Sign in to like collections.",
    "collection.deleteTooltip": "Delete collection",
    "collection.deleteLabel": "Delete",
    "collection.deleteConfirm": "Are you sure you want to delete this collection?",
    "collection.deleted": "Collection deleted",
    "collection.updated": "Collection updated",
    "collection.created": "Your new collection has been created!",
    "collection.addedSuccess": "Page added to collection.",
    "collection.error": "An error occurred. Please try again later.",
    "collection.notFound": "Collection not found or is private.",
    "collection.empty": "No newspaper pages in this collection yet.",
    "collection.createTitle": "Create a new collection",
    "collection.titleLabel": "Collection name",
    "collection.descriptionLabel": "Description",
    "collection.titlePlaceholder": "e.g. Best front pages of the 1940s",
    "collection.titleRequired": "Please enter a collection name.",
    "collection.descriptionPlaceholder": "What is this collection about? (optional)",
    "collection.createButton": "Create Collection",
    "collection.addToTitle": "Add to Collection",
    "collection.yourCollections": "Your collections",
    "collection.noCollectionsYet": "You don't have any collections yet. Create one below!",
    "collection.orDivider": "or",
    "collection.createNew": "Create new collection",

    "collections.title": "Public Collections",
    "collections.subtitle": "Discover curated newspaper page collections created by our community.",
    "collections.sortRecent": "Most Recent",
    "collections.sortPopular": "Most Popular",
    "collections.itemCountLabel": "{count} newspaper pages",
    "collections.emptyTitle": "No public collections yet",
    "collections.emptyDesc": "Be the first to create a public collection!",

    "account.browseCollections": "Browse public collections",

    "arastirmalar.title": "Research Topics",
    "arastirmalar.description": "Research articles and in-depth analyses on the history of the Turkish press.",
    "arastirmalar.subtitle": "Research articles and historical analyses compiled from our archive",
    "arastirmalar.featured": "Featured",
    "arastirmalar.read_more": "Read More",
    "arastirmalar.error": "An error occurred while loading research topics.",
    "arastirmalar.empty": "No research topics available yet.",
    "breadcrumb.home": "Home",
    "index.all_research": "All Research Topics",

    "suggestions.popular": "Popular Searches",
    "suggestions.tags": "Tags",
    "suggestions.newspapers": "Newspapers",

    "theme.label": "Theme",
    "theme.light": "Light",
    "theme.dark": "Dark",
    "theme.system": "System",

    "notFound.metaTitle": "404 — This edition isn't in our archive",
    "notFound.eyebrow": "Late Edition · Error Bulletin",
    "notFound.headline": "This edition isn't in our archive",
    "notFound.subheadline": "The clipping you're looking for may have run in a different edition — or never went to print at all. Don't worry, millions of pages are still waiting to be discovered.",
    "notFound.cta.home": "Back to homepage",
    "notFound.cta.search": "Search the archive",
    "notFound.cta.todayInHistory": "Today in history",
    "notFound.tip": "Tip: double-check the date or newspaper name in the URL — typos are the most common culprit.",

    "ara.emptyState.title": "No results found",
    "ara.emptyState.description": "Try searching with different keywords or filters.",
    "ara.yil": "Year range",
    "index.featured_research": "Featured Research Topics",
    "index.read_more": "Read more",
    "index.tarihte_bugun_share": "Share:",
    "index.tarihte_bugun_card_download": "Download card",
    "email_newsletter.preferences_title": "Email newsletter preferences",
    "gunun_manseti.no_data": "No headline found for this newspaper today.",
    "haber.bulunamadi": "News article not found.",
    "year.importantEvents": "Important Events",
    "year.search.button": "Search",
    "year.search.aria": "Search within year",
    "year.search.placeholder": "Search in this year...",
    "year.search.inputAria": "Search text within year",
  },
  tr: {
    "pricing.loading": "Fiyatlandırma bilgisi yükleniyor...",
    "pricing.error": "Fiyatlandırma bilgisi alınamadı.",
    "pricing.subscribe": "Abone olmak için giriş yapın",
    "pricing.subtitle": "İhtiyaçlarınıza uygun bir abonelik planıyla arşivin tüm gücünü keşfedin.",
    "pricing.monthly": "Aylık",
    "pricing.annual": "Yıllık",
    "pricing.annualSave": "%{percent} tasarruf",
    "pricing.perMonth": "/ay",
    "pricing.perYear": "/yıl",
    "pricing.freeTier": "Ücretsiz",
    "pricing.currentPlan": "Mevcut Plan",
    "pricing.popular": "En Popüler",
    "pricing.feature.viewsPerHour": "Saatlik sayfa görüntüleme",
    "pricing.feature.downloadsPerHour": "Saatlik indirme",
    "pricing.feature.pageDownload": "Sayfa indirme",
    "pricing.feature.pdfDownload": "Sayı PDF indirme",
    "pricing.feature.ocrSearch": "Tam metin OCR arama",
    "pricing.feature.collections": "Koleksiyonlar",
    "pricing.feature.aiTarihci": "Arşiv asistanı (aylık mesaj)",
    "pricing.comparison.title": "Planları Karşılaştırın",
    "pricing.comparison.feature": "Özellik",
    "pricing.stats.newspapers": "100+",
    "pricing.stats.newspapersLabel": "Gazete",
    "pricing.stats.years": "150+",
    "pricing.stats.yearsLabel": "Yıllık Tarih",
    "pricing.stats.pages": "1M+",
    "pricing.stats.pagesLabel": "Gazete Sayfası",
    "pricing.stats.users": "10.000+",
    "pricing.stats.usersLabel": "Kayıtlı Kullanıcı",
    "pricing.guarantee": "Stripe ile güvenli ödeme. İstediğiniz zaman iptal edin.",
    "pricing.subscribeNow": "Abone Ol",
    "pricing.checkoutError": "Ödeme sayfası açılamadı. Lütfen tekrar deneyin.",
    "pricing.faq.title": "Sıkça Sorulan Sorular",
    "pricing.faq.q1": "Aboneliğimi istediğim zaman iptal edebilir miyim?",
    "pricing.faq.a1": "Evet, aboneliğinizi hesap ayarlarınızdan istediğiniz zaman iptal edebilirsiniz. Mevcut fatura döneminizin sonuna kadar erişiminiz devam eder.",
    "pricing.faq.q2": "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
    "pricing.faq.a2": "Güvenli ödeme altyapımız Stripe üzerinden tüm büyük kredi kartlarını (Visa, Mastercard, American Express) kabul ediyoruz.",
    "pricing.faq.q3": "Saatlik limitime ulaştığımda ne olur?",
    "pricing.faq.a3": "Saatlik sayfa görüntüleme ve indirme limitiniz her saatin başında otomatik olarak sıfırlanır. Daha yüksek limitler için planınızı yükseltebilirsiniz.",
    "pricing.faq.q4": "Planımı yükseltebilir veya düşürebilir miyim?",
    "pricing.faq.a4": "Evet, planınızı istediğiniz zaman değiştirebilirsiniz. Yükseltme hemen geçerli olur, düşürme ise mevcut fatura döneminizin sonunda uygulanır.",
    "pricing.cta.title": "Tarihi Keşfetmeye Hazır mısınız?",
    "pricing.cta.subtitle": "Arşivimizi keşfeden binlerce araştırmacı ve tarih meraklısına katılın.",
    "pricing.cta.button": "Yolculuğunuza Başlayın",
    "subscriptionSuccess.title": "Abonelik Başarılı!",
    "subscriptionSuccess.thankYou": "Gaste Arşivi'ne abone olduğunuz için teşekkür ederiz!",
    "subscriptionSuccess.enjoyFeatures": "Artık tüm premium özelliklere erişebilir ve daha yüksek limitlerle arşivi keşfedebilirsiniz.",
    "subscriptionSuccess.processingTime": "Aboneliğinizin hesabınızda görünmesi birkaç dakika sürebilir. Aboneliğiniz aktif görünmüyorsa lütfen kısa süre içinde tekrar kontrol edin.",
    "subscriptionSuccess.goToAccount": "Hesabıma Git",
    "name": "Gaste Arşivi",

    "index.desc" : "Eski gazete arşivi. Eski ve yeni yazıyla geçmiş tarihli gazetelerin sayılarını okuyun, küpürleri görün.",
    "index.page_title": "Gaste Arşivi | 150+ Yıllık Eski Gazete Arşivi — Osmanlı'dan Günümüze",
    "index.arşivdeki_gazeteler" : "Arşivdeki Gazeteler",
    "index.tarihte_bugun": "Tarihte bugün olan olaylar:",
    "tarihte_bugun.view_full": "Tümünü gör",
    "tarihte_bugun.meta.title": "Tarihte bugün — {date} | {name}",
    "tarihte_bugun.meta.description":
      "{date} tarihinde yaşanan olaylar ve doğum günleri; arşivdeki dijital gazete sayfalarıyla bağlantılı. {name}",
    "tarihte_bugun.breadcrumb": "Tarihte bugün",
    "tarihte_bugun.title_fallback": "Tarihte bugün",
    "tarihte_bugun.prev_day": "Önceki gün",
    "tarihte_bugun.next_day": "Sonraki gün",
    "tarihte_bugun.jump_today": "Bugünün tarihine git",
    "tarihte_bugun.empty": "Bu güne ait henüz olay veya doğum günü eklenmedi.",
    "tarihte_bugun.random_covers": "Geçmiş yıllardan bu güne rastgele gazete birinci sayfaları",
    "tarihte_bugun.section.events": "Tarihî olaylar",
    "tarihte_bugun.section.birthdays": "Doğum günleri",
    "tarihte_bugun.not_found": "Sayfa bulunamadı.",
    "tarihte_bugun.no_data_today": "Bu tarih için henüz tarihte bugün içeriği eklenmemiş.",
    "index.gecmisten_bugun": "Geçmişten bu gün tarihli rastgele gazeteler:",
    "index.gunun_mansetleri": "Günün manşetleri",
    "index.gunun_mansetleri_view_all": "Tümünü gör",
    "index.yil_link": "{yil} Yılı",
    "index.hero_title": "150+ Yıllık Gazete Arşivi",
    "index.show_all_newspapers": "Tüm Gazeteleri Göster",
    "index.show_less": "Daha Az Göster",
    "index.show_more": "Daha Fazla Göster",
    "index.step_search": "Arayın",
    "index.step_search_desc": "Milyonlarca gazete sayfasında anahtar kelimelerle arayın.",
    "index.step_explore": "Keşfedin",
    "index.step_explore_desc": "Tarihe, yıla veya gazete adına göre arşivi inceleyin.",
    "index.step_download": "İndirin",
    "index.step_download_desc": "Gazete sayfalarını ve küpürleri cihazınıza indirin.",
    "index.assistant_promo.title": "{name} ile tanışın",
    "index.assistant_promo.body": "{name}, sorularınıza gazete arşivinden yararlanarak yanıt verir. Abonelerimize özeldir.",
    "index.assistant_promo.cta": "Sohbete başla",

    "assistant.metaDescription": "{name} ile tarih hakkında sohbet edin. Yanıtlar gazete arşivine dayanır. Abonelere özel bir özelliktir.",
    "assistant.heroSubtitle": "{name}, arşivdeki gazetelere bakarak istediğiniz araştırmayı yapar ve ilgili sayfaları sizin için bulur. Kullanım limitiniz aylık paketinize göre belirlenir.",
    "assistant.loginPrompt": "{name} ile sohbet etmek için giriş yapın ve abone olun.",
    "assistant.subscribePrompt": "{name} yalnızca aboneler içindir. Paketlerde aylık mesaj hakkı bulunur.",
    "assistant.emptyHint": "Örnek: “1938’de İnönü hakkında gazeteler ne yazıyordu?” veya “Kurtuluş Savaşı’nda İzmir’in işgali nasıl yansımış?”",
    "assistant.sourcesLabel": "Arşivdeki sayfalar",
    "assistant.quota": "Bu ay kalan mesaj",
    "assistant.placeholder": "Sorunuzu yazın…",
    "assistant.send": "Gönder",
    "assistant.limitReached": "Aylık mesaj hakkınız doldu. Dönem yenilendiğinde sıfırlanır veya paketinizi yükseltebilirsiniz.",
    "assistant.error.limit": "Aylık mesaj kotanız doldu.",
    "assistant.error.subRequired": "Bu özellik abonelere özeldir.",
    "assistant.connectionError": "Bağlantı hatası",
    "assistant.thinking": "Yanıt hazırlanıyor",
    "assistant.newChat": "Yeni sohbet",
    "assistant.noTitle": "Başlıksız",
    "assistant.loadError": "Sohbetler yüklenemedi.",
    "assistant.deleteConfirm": "Bu sohbeti silmek istediğinize emin misiniz?",

    "yükleniyor": "Yükleniyor...",

    "ara.cta" : "Gazetelerde arayın",
    "ara.meta.desc": "Eski gazetelerde {query} aramasına ait sonuçlar. {query} haberleri. {query} tarihi",
    "ara.aciklama": `Arama motorlarına benzer şekilde aramalarınızda or kullanabilir, kalıp olarak aramak için terimleri tırnak içine alabilirsiniz. kelimelerinize benzer kelimelerle aramak için esnek ara'yı seçebilirsiniz. Örneğin "geldi" araması esnek arama seçilirse "gel-" kökünden gelen bütün kelimeleri bulacaktır.`,
    "ara.sayfalar.baslik": "{query} içeren sayfalar",
    "ara.pagination.arialabel": "Sayfalar",
    "ara.yilPageLink": "{year} yılına git →",
    "ara.tarihPageLink.human": "{date, date, long} tarihine git →",

    "ara.sort": "Sırala:",
    "ara.sort.best": "En iyi eşleşme",
    "ara.sort.date": "Tarihe göre",
    "ara.filters": "Filtreler",
    "ara.tags": "Etiketler",
    "ara.resultCount": "{count} sonuç",
    "ara.gazetelerCount": "{count} gazete",
    "ara.etiketlerCount": "{count} etiket",
    "ara.clearAll": "Temizle",
    "ara.page.h1": "{query} — gazete arşivinde arama",
    "ara.page.h1.empty": "Gazete arşivinde arama",

    "footer.emailCta": "Bu sitede gazetelerin sayfaları arşivciliğin ruhuna uygun olarak sansürsüz yayınlanmaktadır. Gazetelerdeki yalan veya yanlış haberlerden gazetelerin kendileri sorumludur. Sitemiz gazete sayfalarındaki bilgileri olduğu gibi yayınlar, onların doğru bilgi olduğunu garanti etmez. Her türlü görüş, destek ve önerileriniz için",
    "footer.email": "iletisim@gastearsivi.com",
    "footer.about.desc": "Osmanlı'dan günümüze gazete sayfalarının dijital arşivi.",
    "footer.quickLinks": "Hızlı Bağlantılar",
    "footer.search": "Arama",
    "footer.research": "Araştırmalar",
    "footer.assistant_chat": "{name}",
    "footer.collections": "Koleksiyonlar",
    "footer.todaysHeadlines": "Günün manşetleri",
    "footer.sisterSites": "Kardeş Siteler",
    "footer.contactTitle": "İletişim",
    "footer.privacy": "Gizlilik Politikası",

    "gunun_mansetleri.meta.title": "Günün manşetleri | Gaste Arşivi",
    "gunun_mansetleri.meta.description": "Bugünkü tarihli gazete manşetlerini arşivden inceleyin. Günün manşetleri sayfası.",
    "gunun_mansetleri.page_title": "Günün manşetleri — {tarih}",

    "tarih.meta.title" : "{tarih} Tarihli gazeteler | Gaste Arşivi",
    "tarih.meta.description" : "{tarih} tarihli gazeteleri arşivden okuyun. {tarih} haberleri. {tarih} ne oldu",
    "tarih.gunBilgisi": "O gün neler oldu?",
    "tarih.showMore": "Daha fazla göster",
    "tarih.showLess": "Daha az göster",
    "tarih.commonTags": "Bu günün etiketleri",
    "tarih.newsArticles": "Bu güne ait haber makaleleri",

    "Gazete.description": "{ad} {tip}'ne ait eski sayıları arşivden oku. {ad} {tip} arşivi",
    "Gazete.title" : "{ad} {tip} Arşivi",
    "Gazete.archiveInfo": "Arşivde {ilkYil} ve {sonYil} yılları arasında {toplamSayi} sayı bulunmaktadır. Takvimden sayı olan bir günü seçebilir veya tüm sayılara göz atabilirsiniz.",
    "Gazete.allIssues": "Tüm sayılar",
    "Gazete.allIssuesPage": "Tüm sayılar sayfa {page}",

    "GazeteSayısı.meta.title": "{gazete} {tarih} | Gaste Arşivi",
    "GazeteSayısı.meta.desc" : "{tarih} Tarihli {gazete} {tip}'ni arşivden okuyun. {tarih} tarihli {gazete} haberleri",
    "GazeteSayısı.sayfaTitle" : "Sayfa {sayfa}",
    "GazeteSayısı.title" : "{tarih} Tarihli {gazete} {tip}",

    "GazeteSayfası.meta.title" : "{ad} {tarih} sayfa {sayfa} | Gaste Arşivi",
    "GazeteSayfası.imageAlt": "{tarih} tarihli {ad} {tip} Sayfa {sayfa}",
    "GazeteSayfası.digerSayfalar": "Bu sayıdan diğer sayfalar:",
    "GazeteSayfası.metinİçeriği" : "Tam metin içeriği",
    "GazeteSayfası.cut": "Kes",
    "GazeteSayfası.add": "Ekle",
    "GazeteSayfası.download": "Sayfayı indir",
    "GazeteSayfası.downloadCta": "Gazete sayfalarını indirebilmek için abone olabilirsiniz! Abonelerimize özel bu ayrıcalıktan yararlanmak için hemen kaydolun!",
    "GazeteSayfası.downloadPdf": "Sayıyı PDF İndir",
    "GazeteSayfası.downloadPdfTooltip": "Bu sayıyı PDF olarak indir",
    "GazeteSayfası.downloadPdfAriaLabel": "Tüm sayıyı PDF İndir",
    "GazeteSayfası.downloadPdfCta": "Tüm sayıyı PDF olarak indirebilmek için abone olabilirsiniz! Abonelerimize özel bu ayrıcalıktan yararlanmak için hemen kaydolun!",
    "GazeteSayfası.downloadPdfError": "PDF indirilemedi. Lütfen daha sonra tekrar deneyin.",
    "GazeteSayfası.tags": "Etiketler:",
    "GazeteSayfası.pageLimit": "Saatlik sayfa görüntüleme limitine ulaştınız. Daha yüksek sayfa görüntüleme limiti ve diğer özellikler için abone olun!",
    "GazeteSayfası.limitExplanation": "Aboneler yüksek görüntüleme limiti, sayfa indirme ve diğer özel özelliklerden yararlanır. Aboneliğiniz güvenlidir ve istediğiniz zaman kolayca iptal edebilirsiniz.",
    "GazeteSayfası.limitKalan": "Kalan görüntüleme: {limit}",
    "GazeteSayfası.softPaywallCritical": "Son {remaining} görüntülemeniz kaldı! Abone olarak limiti artırabilirsiniz.",
    "GazeteSayfası.osShare": "Paylaş",
    "GazeteSayfası.cropTooltip": "Kırp (Bölge seç)",
    "GazeteSayfası.cropAriaLabel": "Kırp",
    "GazeteSayfası.cancelCropTooltip": "Kırpmayı iptal et",
    "GazeteSayfası.cancelCropAriaLabel": "İptal",
    "GazeteSayfası.cancelCrop": "İptal",
    "GazeteSayfası.applyCropTooltip": "Kırpmayı uygula",
    "GazeteSayfası.applyCropAriaLabel": "Onayla",
    "GazeteSayfası.applyCrop": "Onayla",
    "GazeteSayfası.addToCollectionTooltip": "Koleksiyona ekle",
    "GazeteSayfası.addToCollectionAriaLabel": "Koleksiyona ekle",
    "GazeteSayfası.downloadTooltip": "Sayfayı indir",
    "GazeteSayfası.downloadAriaLabel": "İndir",
    "GazeteSayfası.shareFacebookTooltip": "Facebook'ta paylaş",
    "GazeteSayfası.shareFacebookAriaLabel": "Facebook'ta paylaş",
    "GazeteSayfası.shareWhatsappTooltip": "Whatsapp'ta paylaş",
    "GazeteSayfası.shareWhatsappAriaLabel": "Whatsapp'ta paylaş",
    "GazeteSayfası.sharePinterestTooltip": "Pinterest'te paylaş",
    "GazeteSayfası.sharePinterestAriaLabel": "Pinterest'te paylaş",
    "GazeteSayfası.shareTwitterTooltip": "Twitter'da paylaş",
    "GazeteSayfası.shareTwitterAriaLabel": "Twitter'da paylaş",
    "GazeteSayfası.shareOSTooltip": "Cihazda paylaş",
    "GazeteSayfası.shareOSAriaLabel": "Cihazda paylaş",
    "GazeteSayfası.backToTopAriaLabel": "Başa dön",
    "GazeteSayfası.backToTopTooltip": "Başa dön",
    "GazeteSayfası.sayfa": "Sayfa {sayfa}",
    "GazeteSayfası.title": "{ad} Gazetesi, {tarih}, Sayfa {sayfa}",
    "GazeteSayfası.oncekiGun": "Önceki Gün",
    "GazeteSayfası.sonrakiGun": "Sonraki Gün",
    "GazeteSayfası.oncekiSayfa": "Önceki sayfa",
    "GazeteSayfası.sonrakiSayfa": "Sonraki sayfa",
    "GazeteSayfası.küpürlerTitle": "Sayfaya ait küpürler",
    "GazeteSayfası.aynıGün": "Aynı güne ait diğer gazeteler",
    "GazeteSayfası.meta.description": "{tarih} tarihli {ad} sayfa {sayfa}'yı arşivden okuyun",
    "GazeteSayfası.meta.headline": "{tarih} tarihli {ad} sayfa {sayfa}",
    "GazeteSayfası.og.title": "{tarih} tarihli {ad} sayfa {sayfa}",
    "GazeteSayfası.showLess": "Daha az",
    "GazeteSayfası.showMore": "daha",
    "GazeteSayfası.summary": "Özet",
    "GazeteSayfası.copyText": "Metni kopyala",
    "GazeteSayfası.textCopied": "Metin kopyalandı",
    "GazeteSayfası.downloadLimitError": "İndirme limitinize ulaştınız. Lütfen limitinizin sıfırlanmasını bekleyin veya aboneliğinizi yükseltin.",
    "GazeteSayfası.downloadError": "Dosya indirilemedi. Lütfen daha sonra tekrar deneyin.",

    "year.title" : "{year} Yılı Gazete Arşivi - {year} Yılında Neler Oldu | Gaste Arşivi",
    "year.description" : "{year} yılına ait eski gazete sayfalarını gün gün inceleyin. {year} yılında neler oldu, hangi haberler manşet oldu? Gazete arşivinden tarihî sayıları okuyun.",
    "year.breadcrumb" : "{year} Yılı",
    "year.heading" : "{year} Yılı Haberleri - Gün Gün Tüm Sayfalar",
    "year.invalidYear" : "Geçerli bir yıl girin lütfen. Bu yıl arşivde herhangi bir sayı bulunmamaktadır.",
    "year.dayWithIssues" : "{date} - Gazete sayıları mevcut",
    "year.dayWithIssuesAriaLabel" : "{day} {month} {year} - Gazete sayıları mevcut",
    "year.legend.noissues" : "Sayısı olmayan günler",
    "year.legend.withIssues" : "Sayısı olan günler",
    "year.showMore": "Daha fazla göster",
    "year.showLess": "Daha az göster",
    "year.commonTags": "Bu yılın ortak etiketleri",
    "year.og.title": "{year} Yılı Gazete Arşivi - Eski Gazete Sayfaları | Gaste Arşivi",
    "year.og.description": "{year} yılına ait tüm gazete sayfalarını keşfedin. Günlük sayıları gün gün inceleyin, manşetleri görün ve arşivlenmiş eski gazeteleri okuyun.",

    "year.etiket.title": "{year} yılı {tag} sayfaları | Gaste Arşivi",
    "year.etiket.description": "{year} yılında {tag} haberleri. Gazete arşivinde {year} yılında {tag} ile etiketlenmiş sayfalar.",
    "year.etiket.heading": "{year} yılı için {tag} ile ilgili sayfalar",
    "year.etiket.error": "Etiketli sayfalar yüklenirken hata oluştu.",
    "year.etiket.empty": "Bu yıl için bu etiketle işaretlenmiş sayfa bulunamadı.",

    "home" : "Ana Sayfa",
    "loading" : "Yükleniyor...",

    "login.giris_yap": "Giriş yap",
    "login.k_adi": "Kullanıcı adı veya e-mail",
    "login.sifre": "Şifre",
    "login.uye_ol_cta": "Üye değil misiniz? Şimdi olun!",
    "login.uye_ol": "Üye ol",
    "login.patreon": "Patreon ile giriş yap",
    "login.google": "Google ile Giriş",
    "login.forgot_password": "Şifremi unuttum",
    "login.reset_email_sent": "Eğer e-posta kayıtlıysa, bir sıfırlama bağlantısı gönderildi.",
    "login.send_reset": "Sıfırlama Bağlantısı Gönder",
    "login.cancel": "İptal",
    "login.set_new_password": "Yeni Şifre Belirle",
    "login.reset_link_invalid": "Bu şifre sıfırlama bağlantısı geçersiz veya eksik. Giriş ekranından yeni bir bağlantı isteyin.",
    "login.password_strength_hint": "En az 8 karakter; küçük ve büyük harf, rakam ve sembol içermelidir.",
    "login.password_reset_success": "Şifreniz güncellendi. Artık giriş yapabilirsiniz.",
    "login.set_password": "Şifreyi Belirle",
    "login.back_to_login": "Girişe dön",
    "login.or": "veya",
    "login.greeting": "Hoş geldiniz! 👋",

    "signup.email": "E-mail",
    "signup.login_cta": "Zaten üye misiniz? Giriş yapın!",
    "signup.login": "Giriş yap",

    "subscribeModal.cta": "Gaste Arşivi'nin tüm gücünü keşfedin!",
    "subscribeModal.button": "Hemen Abone Olun",
    "subscribeModal.cancel": "Düşüneceğim",
    "subscribeModal.p1": "Sayfa indirme, sınırsız görüntüleme ve 150+ yıllık gazete tarihini keşfetmek için abone olun.",
    "subscribeModal.feature.downloads": "Yüksek kaliteli sayfa indirme",
    "subscribeModal.feature.unlimitedViews": "Saatte daha fazla görüntüleme",
    "subscribeModal.feature.pdf": "Tam sayı PDF indirme",
    "subscribeModal.feature.ocrSearch": "Tam metin OCR arama",
    "subscribeModal.choosePlan": "İhtiyacınıza uygun planı seçin:",

    "subscription.title": "Abonelik Paketleri",
    "subscription.description": "Merhaba {username}, Gazete arşivimize abone olarak tüm özelliklere erişebilir ve projeye destek olabilirsiniz. Aşağıdaki abonelik paketlerinden size uygun olanı seçebilirsiniz.",
    "subscription.manage": "Aboneliği düzenle",

    "header.chooseOption": "--Bir seçenek seçin--",
    "header.flexibleSearch": "Esnek ara:",
    "header.account": "Hesabım",
    "header.signin": "Giriş Yap",
    "header.signup": "Kayıt Ol",
    "account.hello": "Merhaba, {username}",
    "account.subscription": "Abonelik: {subscription}",
    "account.notSubscribed": "Abone değilsin",
    "account.manageSubscription": "Aboneliği düzenle",
    "account.subscribe": "Abone ol",
    "account.collections": "Koleksiyonların:",
    "account.noCollections": "Henüz bir koleksiyon oluşturmadın.",
    "account.supportPatreon": "Patreon'da destek ol!",
    "account.logout": "Çıkış yap",
    "account.loading": "Yükleniyor...",
    "account.subscriptionPastDue": "Ödeme alımı deneniyor",
    "account.manageSubscriptionTooltip": "Aboneliğini yönet",
    "account.subscribeTooltip": "Abone ol ve avantajlardan yararlan",
    "account.viewCollection": "Koleksiyonu görüntüle",
    "account.createCollectionCta": "Yeni koleksiyon oluşturmak için arama yapabilirsin!",
    "account.supportPatreonTooltip": "Patreon üzerinden destek ol",
    "account.logoutTooltip": "Çıkış yap ve hesabından güvenle ayrıl",
    "account.viewLimit": "Görüntüleme hakkı: {left}, sıfırlanma zamanı: {resetAt}",
    "account.downloadLimit": "Sayfa indirme hakkı: {left}, sıfırlanma zamanı: {resetAt}",
    "account.downloadCredits": "Ek indirme kredisi: {credits}",
    "account.purchaseCredits": "Ek İndirme Hakkı Satın Al",
    "account.limits": "Limitler",
    "downloadCredits.title": "Sayfa İndirme Kredisi Satın Al",
    "downloadCredits.currentBalance": "Mevcut krediniz: {balance}",
    "downloadCredits.description": "Saatlik sayfa indirme limitiniz dolduğunda kullanmak için ek indirme kredisi satın alabilirsiniz.",
    "downloadCredits.pdfCostsCredits": "Tam sayıyı PDF olarak indirdiğinizde dosyadaki her sayfa için birer kredi düşülür; çok sayfalı bir gazete tek seferde çok kredi kullanır.",
    "downloadCredits.trySinglePage": "Daha az kredi kullanmak için tam sayı yerine yalnızca bir sayfayı indirmeyi deneyebilirsiniz; bu tek kredi harcar.",
    "downloadCredits.credits": "{count} Kredi",
    "downloadCredits.continue": "Devam Et",
    "downloadCredits.cancel": "İptal",
    "downloadCredits.loading": "Yükleniyor...",
    "downloadCredits.processing": "İşleniyor...",
    "downloadCredits.pay": "Satın Al",
    "downloadCredits.paymentTitle": "Ödeme Bilgileri",
    "downloadCredits.paymentDescription": "{credits} kredi için {price}",
    "downloadCredits.successTitle": "Satın Alma Başarılı!",
    "downloadCredits.successMessage": "{credits} indirme kredisi hesabınıza eklendi.",
    "downloadCredits.packageDescription": "{count} indirme kredisi",
    "downloadCredits.fetchError": "Paketler yüklenemedi. Lütfen tekrar deneyin.",
    "downloadCredits.paymentError": "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
    "GazeteSayfası.downloadLimitErrorWithCredits": "İndirme limitinize ulaştınız. Ek indirme kredisi satın alabilirsiniz.",
    "GazeteSayfası.buyCredits": "Kredi Satın Al",
    "etiket.title": "{etiket} ile ilgili sayfalar | Gaste Arşivi",
    "etiket.description": "Arşivden {etiket} ile ilgili gazete sayfaları. {etiket} haberleri. {etiket} tarihi. {etiket} ile ilgili bilgiler.",
    "etiket.taggedPages": "{etiket} etiketli sayfalar",
    "etiket.goToDefinition": "Tanıma Git",
    "etiket.richDescription": "\"{etiket}\" ile ilgili {toplam} sayfa bulundu, {minYear}\u2013{maxYear} yılları arasında.",
    "etiket.richDescriptionNoRange": "\"{etiket}\" ile ilgili {toplam} sayfa bulundu.",
    "etiket.relatedTags": "İlgili Etiketler",
    "etiket.schema.name": "{etiket} etiketi — gazete sayfaları",
    "Gazete.navigation": "Sonuçlar",
    "index.intro": "Türkiye'nin dijital gazete arşivinde geçmişe yolculuk yapın, eski gazeteleri keşfedin ve aradığınız haberlere kolayca ulaşın.",
    "GazeteSayfası.censoredLegalTitle": "Bu sayfaya ülkenizdeki yasal nedenlerle erişime kısıtlanmıştır.",
    "GazeteSayfası.censoredLegalExplanation": "Bu gazete sayfası, ülkenizde geçerli olan yasal kısıtlamalar nedeniyle görüntülenememektedir.",

    "datePicker.months.0": "Ocak",
    "datePicker.months.1": "Şubat",
    "datePicker.months.2": "Mart",
    "datePicker.months.3": "Nisan",
    "datePicker.months.4": "Mayıs",
    "datePicker.months.5": "Haziran",
    "datePicker.months.6": "Temmuz",
    "datePicker.months.7": "Ağustos",
    "datePicker.months.8": "Eylül",
    "datePicker.months.9": "Ekim",
    "datePicker.months.10": "Kasım",
    "datePicker.months.11": "Aralık",
    "datePicker.weekdays.0": "Paz",
    "datePicker.weekdays.1": "Pzt",
    "datePicker.weekdays.2": "Sal",
    "datePicker.weekdays.3": "Çar",
    "datePicker.weekdays.4": "Per",
    "datePicker.weekdays.5": "Cum",
    "datePicker.weekdays.6": "Cmt",
    "datePicker.prevMonth": "Önceki ay",
    "datePicker.nextMonth": "Sonraki ay",
    "datePicker.selectYear": "Yıl seç",
    "datePicker.selectMonth": "Ay seç",
    "datePicker.noIssues": "Bu tarihte sayı bulunmuyor",
    "datePicker.hasIssues": "Sayı var",
    "datePicker.noIssuesLegend": "Sayı yok",

    "collection.public": "Herkese açık",
    "collection.private": "Gizli",
    "collection.makePublic": "Herkese Aç",
    "collection.makePrivate": "Gizle",
    "collection.makePublicLabel": "Bu koleksiyonu herkese açık yap",
    "collection.publicHint": "Herkese açık koleksiyonlar herkes tarafından görülebilir ve beğenilebilir.",
    "collection.by": "{username} tarafından",
    "collection.itemCount": "{count} sayfa",
    "collection.likeTooltip": "Bu koleksiyonu beğen",
    "collection.loginToLike": "Koleksiyonları beğenmek için giriş yapın.",
    "collection.deleteTooltip": "Koleksiyonu sil",
    "collection.deleteLabel": "Sil",
    "collection.deleteConfirm": "Bu koleksiyonu silmek istediğinizden emin misiniz?",
    "collection.deleted": "Koleksiyon silindi",
    "collection.updated": "Koleksiyon güncellendi",
    "collection.created": "Yeni koleksiyonunuz oluşturuldu!",
    "collection.addedSuccess": "Gazete sayfası koleksiyona eklendi.",
    "collection.error": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    "collection.notFound": "Koleksiyon bulunamadı veya gizli.",
    "collection.empty": "Koleksiyonunuzda henüz gazete sayfası yok.",
    "collection.createTitle": "Yeni bir koleksiyon oluşturun",
    "collection.titleLabel": "Koleksiyon ismi",
    "collection.descriptionLabel": "Açıklama",
    "collection.titlePlaceholder": "örn. 1940'ların en iyi manşetleri",
    "collection.titleRequired": "Lütfen bir koleksiyon ismi girin.",
    "collection.descriptionPlaceholder": "Bu koleksiyon ne hakkında? (isteğe bağlı)",
    "collection.createButton": "Koleksiyonu oluştur",
    "collection.addToTitle": "Koleksiyona Ekle",
    "collection.yourCollections": "Koleksiyonların",
    "collection.noCollectionsYet": "Henüz koleksiyonun yok. Aşağıdan yeni bir tane oluştur!",
    "collection.orDivider": "veya",
    "collection.createNew": "Yeni koleksiyon oluştur",

    "collections.title": "Herkese Açık Koleksiyonlar",
    "collections.subtitle": "Topluluğumuz tarafından oluşturulan gazete sayfası koleksiyonlarını keşfedin.",
    "collections.sortRecent": "En Yeni",
    "collections.sortPopular": "En Popüler",
    "collections.itemCountLabel": "{count} gazete sayfası",
    "collections.emptyTitle": "Henüz herkese açık koleksiyon yok",
    "collections.emptyDesc": "İlk herkese açık koleksiyonu oluşturun!",

    "account.browseCollections": "Herkese açık koleksiyonlara göz at",

    "arastirmalar.title": "Araştırma Konuları",
    "arastirmalar.description": "Türk basın tarihi üzerine araştırma yazıları ve derinlemesine analizler.",
    "arastirmalar.subtitle": "Arşivimizden derlenen araştırma yazıları ve tarihi analizler",
    "arastirmalar.featured": "Öne Çıkan",
    "arastirmalar.read_more": "Devamını Oku",
    "arastirmalar.error": "Araştırma konuları yüklenirken bir hata oluştu.",
    "arastirmalar.empty": "Henüz araştırma konusu bulunmuyor.",
    "breadcrumb.home": "Ana Sayfa",
    "index.all_research": "Tüm Araştırma Konuları",

    "suggestions.popular": "Popüler Aramalar",
    "suggestions.tags": "Etiketler",
    "suggestions.newspapers": "Gazeteler",

    "theme.label": "Tema",
    "theme.light": "Açık",
    "theme.dark": "Koyu",
    "theme.system": "Sistem",

    "notFound.metaTitle": "404 — Bu sayfa arşivimizde yok",
    "notFound.eyebrow": "Son baskı · Hata bülteni",
    "notFound.headline": "Bu sayfa arşivimizde yok",
    "notFound.subheadline": "Aradığınız haber kupürü ya başka bir baskıya gitmiş ya da hiç basılmamış olabilir. Endişelenmeyin — milyonlarca sayfa hâlâ keşfetmenizi bekliyor.",
    "notFound.cta.home": "Ana sayfaya dön",
    "notFound.cta.search": "Arşivde ara",
    "notFound.cta.todayInHistory": "Tarihte bugün",
    "notFound.tip": "İpucu: URL'deki tarih veya gazete adını kontrol edin — yazım hataları en sık karşılaşılan suçlulardan.",

    "ara.kupurler": "Bulunan küpürler",
    "ara.sayfaTitle": "{ad} {tarih} Sayfa {sayfa}",
    "ara.meta.title": "{query} | Gaste Arşivi",
    "ara.button": "Ara",
    "ara.gazete": "Gazete:",
    "ara.fromDate": "Başlangıç tarihi:",
    "ara.endDate": "Bitiş tarihi:",
    "ara.cancel": "İptal",
    "ara.yil": "Yıl aralığı",
    "ara.emptyState.title": "Sonuç bulunamadı",
    "ara.emptyState.description": "Farklı anahtar kelimeler veya filtreler deneyerek tekrar arayabilirsiniz.",
    "Gazete.arasıSayılar": "{ilk} ile {son} arası sayılar",
    "GazeteSayısı.og.title": "{tarih} tarihli {gazete} sayısı",
    "GazeteSayısı.og.desc": "Arşivdeki tüm sayıları okuyun.",
    "tarih.title": "{tarih} tarihli gazeteler",
    "index.aramalarTitle": "Bugün en çok aranan:",
    "index.yillarTitle": "Arşivdeki yıllar:",
    "index.featured_research": "Öne Çıkan Araştırma Konuları",
    "index.read_more": "Devamını Oku",
    "index.tarihte_bugun_share": "Paylaş:",
    "index.tarihte_bugun_card_download": "Kartı indir",
    "email_newsletter.preferences_title": "E-posta bülten tercihleri",
    "gunun_manseti.no_data": "Bu gazete için bugüne ait manşet bulunamadı.",
    "haber.bulunamadi": "Haber makalesi bulunamadı.",
    "year.importantEvents": "Önemli Olaylar",
    "year.search.button": "Ara",
    "year.search.aria": "Yıl içinde ara",
    "year.search.placeholder": "Bu yılda ara...",
    "year.search.inputAria": "Yıl içinde arama metni",
  },
};
